module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_m_normal.91ea34e6.png";